import React from "react";
import MaterialTable from "material-table";
import { Paper } from "@material-ui/core";
import Service from '../../config/networkutils';
import { withSnackbar } from 'notistack';
import Auth from '../../utils/authenticate';


const token = Auth.token();


class TagLabelTable extends React.Component {
    state = {
        data: [],
        loading: true
    }
    getTagRows(data) {
        return (Array.isArray(data) ? data : [])
            .filter(row => row && typeof row === 'object' && !row.is_deleted)
    }
    componentDidMount() {
        this.getData();
    }

    getData(){
           Service.get('/api/tag/get_all_tags/', {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            let resData = this.getTagRows(res.data)
            this.setState({ data: resData, loading: false })
        }).catch(error => {
            if (error.status === 403) {
                this.props.enqueueSnackbar(error.data.message + ' for ' + this.props.tableName, {
                    variant: 'warning'
                })
            } else {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            }
        })
    }

    postOps(data) {
        Service.post('/api/tag/create_tag/', {
            headers: {
                Authorization: "Token " + token,
            },
            data
        }).then(res => {
            let dupData = [...this.state.data, ...this.getTagRows([res.data])]
            this.getData();
            this.setState({ data: dupData })
            this.props.enqueueSnackbar('Tag Label created!', { variant: 'success' })

        }).catch(error => {
            this.props.enqueueSnackbar('Tag Label creation failed !', { variant: 'error' })
        })
    }
    putOps(data) {
        Service.patch('/api/tag/update_tag/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                id: data.id,
                name: data.name
            }
        }).then(res => {
            let dupData = [...this.state.data]
            dupData.forEach((row, rowIndex) => {
                if (row.id === data.id) {
                    dupData[rowIndex].name = data.name
                }
            })
            this.setState({ data: dupData })
            this.props.enqueueSnackbar('Tag Label updated!', { variant: 'success' })
        }).catch(error => {
            this.props.enqueueSnackbar('Tag Label updation failed !', { variant: 'error' })
        })
    }
    deleteOps(data) {
        Service.delete('/api/tag/delete_tag/' + data + "/", {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            let dupData = [...this.state.data]
            dupData = dupData.filter(row => row.id !== data)
            this.setState({ data: dupData })

            this.props.enqueueSnackbar('Tag Label Deleted!', { variant: 'success' })

        }).catch(error => {
            this.props.enqueueSnackbar('Tag Label Deletion failed !', { variant: 'error' })
        })
    }
    render() {
        return (
            <Paper elevation={1}>
                <MaterialTable
                    title={'Tag Labels'}
                    columns={[{ title: 'Tag Label', field: 'name' },]}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    editable={{
                        onRowAdd: newData =>
                            new Promise((resolve, reject) => {
                                setTimeout(() => {
                                    this.postOps({ ...newData, type: 0 })

                                    resolve();
                                }, 1000);
                            }),

                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve, reject) => {
                                setTimeout(() => {

                                    this.putOps({ ...newData, type: 0 })

                                    resolve();
                                }, 1000);
                            }),
                    }}
                >
                </MaterialTable>
            </Paper>
        );
    }
}

export default withSnackbar(TagLabelTable);